import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import dynamic from "next/dynamic";
import { BmLogo, CgLogo, Floyt } from "./assets";
// These logos should never be lazy-loaded
var LogoMapping = {
    bm: BmLogo,
    cg: CgLogo,
    floyt: Floyt
};
var providers = [
    "bmInverted",
    "cgInverted",
    "topdeal",
    "trustpilot",
    "alamo",
    "avis",
    "budget",
    "enterprise",
    "europcar",
    "hertz",
    "rentalcars", 
];
var ImageSVG = function(param) {
    var name = param.name, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    var ImageComponent = LogoMapping[name] || Fragment;
    if (loading === "eager") {
        return /*#__PURE__*/ _jsx(ImageComponent, {});
    }
    var DynamicImageComponent = dynamic(function() {
        return(// eslint-disable-next-line @typescript-eslint/no-unused-vars
        import("./assets/".concat(name)).catch(function(_err) {
            return null;
        }));
    });
    return /*#__PURE__*/ _jsx(DynamicImageComponent, {});
};
export { ImageSVG };
